import * as React from "react";
import styled, { css } from "styled-components";
import { StatCard } from "components/common";
import NumberUtils from "util/NumberUtils";
const PlateGrid = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.spacings.md};
  `
);
const formatNumber = (value) => NumberUtils.formatNumber(value);
const formatTokenShare = (part, total) => NumberUtils.formatPercentage(total > 0 ? part / total : 0);
const UsagePlateStats = ({ summary }) => /* @__PURE__ */ React.createElement(PlateGrid, null, /* @__PURE__ */ React.createElement(
  StatCard,
  {
    variant: "primary",
    label: "Total tokens",
    value: formatNumber(summary.total_tokens),
    subValue: "Total reported by filters"
  }
), /* @__PURE__ */ React.createElement(
  StatCard,
  {
    variant: "info",
    label: "Input tokens",
    value: formatNumber(summary.input_tokens),
    subValue: `${formatTokenShare(summary.input_tokens, summary.total_tokens)} of total`
  }
), /* @__PURE__ */ React.createElement(
  StatCard,
  {
    variant: "success",
    label: "Output tokens",
    value: formatNumber(summary.output_tokens),
    subValue: `${formatTokenShare(summary.output_tokens, summary.total_tokens)} of total`
  }
));
export default UsagePlateStats;
